import {Field} from 'formik';

import {
    FormikNumberInput,
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Stack} from '@mantine/core';


export const FormComponent = () => {

    return (
        <Stack gap={'xl'}>
            <PlatformFieldset legend={'Step Details'}>
                {/* phaseId and playbookId are seeded from the route params and are
                    not user-editable. They are kept as hidden Formik fields so
                    they flow through to the mutation payload. */}
                <Field name='phaseId' type='hidden' component='input'/>
                <Field name='playbookId' type='hidden' component='input'/>

                <Field
                    name='name'
                    label='Name'
                    description='Machine-readable identifier (e.g. "validate-domain-prereqs")'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='displayName'
                    label='Display Name'
                    description='Human-friendly name shown in the UI'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='description'
                    label='Description'
                    description='What this step does'
                    component={FormikTextarea}
                    my={'xl'}
                />

                <Field
                    name='position'
                    label='Position'
                    description='Order of this step within the phase (zero-based, ascending)'
                    component={FormikNumberInput}
                    withAsterisk
                    my={'xl'}
                />
            </PlatformFieldset>

            <PlatformFieldset legend={'Execution Binding'}>
                <Field
                    name='taskStateName'
                    label='Task State Name'
                    description='Step Functions task-state identifier (e.g. "ValidateDomainPrereqs")'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='targetService'
                    label='Target Service'
                    description='Downstream AppSync API name (e.g. "flexi-domains-api")'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='targetOperation'
                    label='Target Operation'
                    description='GraphQL query/mutation field name (e.g. "validateApplicationDomainPrerequisites")'
                    component={FormikTextInput}
                    my={'xl'}
                />
            </PlatformFieldset>

            {/* FNP-999: per-step orchestrator parameters. The API stores this as
                AWSJSON — a STRING containing JSON — so it is edited as raw JSON
                text and validated by RecordSchema before submit. Leaving it
                empty omits the field entirely rather than clearing it; see
                normalizeParameters in StepsService. */}
            <PlatformFieldset legend={'Parameters'}>
                <Field
                    name='parameters'
                    label='Parameters (JSON)'
                    description={
                        'Per-step parameters passed to the orchestrator, as a JSON object. ' +
                        'Example: {"repoNameSuffix":"-test","stagesToValidate":["test"]}. ' +
                        'Leave empty to make no change to the existing value.'
                    }
                    component={FormikTextarea}
                    autosize
                    minRows={4}
                    my={'xl'}
                />
            </PlatformFieldset>
        </Stack>
    );
};
